import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { ListPlus, Plus } from 'lucide-react';

// Formules préparées à insérer dans les remarques devis (textes à compléter)
export const FORMULES_REMARQUES = [
    {
        id: 'preparation_1_jour',
        label: 'Déménagement avec 1 jour de préparation',
        texte: [
            '**Organisation du déménagement sur 2 jours**',
            '__Jour 1 – Préparation de votre déménagement__',
            'Notre équipe assure la mise en cartons de vos effets personnels, le démontage des éléments nécessaires ainsi que la protection complète de vos biens afin de préparer leur transport dans les meilleures conditions.',
            '__Jour 2 – Déménagement et installation__',
            'Prise en charge du chargement, transport jusqu\u2019à votre nouvelle adresse, déchargement et installation. Notre équipe assure également le déballage des cartons fragiles.',
        ].join('\n'),
    },
    {
        id: 'longue_distance_2_jours',
        label: 'Déménagement longue distance sur 2 jours',
        texte: [
            '**Organisation de votre déménagement longue distance sur 2 jours**',
            '__Jour 1 – Protection, chargement et départ__',
            'Notre équipe protège soigneusement vos biens et assure leur chargement dans le véhicule. Une fois l\u2019ensemble sécurisé pour le transport, nous prenons la route vers votre nouvelle adresse.',
            '__Jour 2 – Livraison et installation__',
            'Nous assurons le déchargement à destination et la mise en place de vos meubles et cartons dans les pièces de votre choix, pour faciliter votre installation dans votre nouveau logement.',
        ].join('\n'),
    },
    {
        id: 'route_1_jour_preparation',
        label: 'Route 2 j avec 1 jour de prépa',
        texte: [
            '**Organisation de votre déménagement longue distance sur 3 jours**',
            '__Jour 1 – Préparation de votre déménagement__',
            'Notre équipe assure la mise en cartons de vos effets personnels, le démontage du mobilier et la protection soigneuse de vos biens afin de préparer leur transport dans les meilleures conditions.',
            '__Jour 2 – Chargement et départ__',
            'Nous procédons au chargement de l\u2019ensemble dans le véhicule. Une fois vos biens sécurisés pour le transport, nous prenons la route vers votre nouvelle adresse.',
            '__Jour 3 – Livraison, remontage et installation__',
            'À destination, nous assurons le déchargement, le remontage de vos meubles et la mise en place de vos biens dans les pièces de votre choix. Notre équipe procède également au déballage des objets fragiles pour faciliter votre installation dans votre nouveau logement.',
        ].join('\n'),
    },
    {
        id: 'article_a_demonter',
        label: 'Article à démonter',
        texte: [
            '**Démontage et remontage du mobilier**',
            'Notre équipe prend en charge le démontage au départ et le remontage à destination des éléments suivants :',
        ].join('\n'),
    },
    {
        id: 'objets_lourds',
        label: 'Objets lourds',
        texte: [
            '**Manutention et transport des objets lourds**',
            'Notre équipe prend en charge la manutention, le transport et la mise en place à destination des objets lourds suivants :',
        ].join('\n'),
    },
];

export function FormulesRemarquesDialog({ open, onOpenChange, onAdd }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-lg" data-testid="formules-remarques-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <ListPlus size={18} className="text-[#2e7cd6]" /> Formules préparées
                    </DialogTitle>
                    <DialogDescription>Cliquez sur + pour ajouter une formule dans les remarques, dans l'ordre souhaité.</DialogDescription>
                </DialogHeader>
                <div className="space-y-2 max-h-[50vh] overflow-y-auto pr-1">
                    {FORMULES_REMARQUES.map((f) => (
                        <div
                            key={f.id}
                            className="flex items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2 hover:border-slate-300 transition-colors"
                            data-testid={`formule-remarque-${f.id}`}
                        >
                            <span className="flex-1 text-sm text-slate-800">{f.label}</span>
                            <Button
                                type="button"
                                size="sm"
                                onClick={() => onAdd(f.texte)}
                                className="h-8 w-8 p-0 bg-[#2e7cd6] hover:bg-[#2568b8] text-white shrink-0"
                                title="Ajouter dans les remarques"
                                data-testid={`formule-remarque-add-${f.id}`}
                            >
                                <Plus size={16} />
                            </Button>
                        </div>
                    ))}
                </div>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="formules-remarques-close">Fermer</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
